export const REPOST_TOAST_TIMEOUT_MILLIS = 1000
export const SHARE_TOAST_TIMEOUT_MILLIS = 1500
export const NEW_WALLET_CONNECTED_TOAST_TIMEOUT_MILLIS = 3000
export const CLAIM_REWARD_TOAST_TIMEOUT_MILLIS = 3000

export const COGNITO_SCRIPT_URL = 'https://cdn.cognitohq.com/flow.js'
